var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppGlobalLayout',{attrs:{"loading":_vm.loading,"error":_vm.error},on:{"reload":_vm.loadInfo}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('AccountCounter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }